module.exports = __webpack_public_path__ + "img/6.00374029.png";